import { render, staticRenderFns } from "./ViewImage.vue?vue&type=template&id=b695c9d4&scoped=true&"
import script from "./ViewImage.vue?vue&type=script&lang=js&"
export * from "./ViewImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b695c9d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b695c9d4')) {
      api.createRecord('b695c9d4', component.options)
    } else {
      api.reload('b695c9d4', component.options)
    }
    module.hot.accept("./ViewImage.vue?vue&type=template&id=b695c9d4&scoped=true&", function () {
      api.rerender('b695c9d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/welfare/mixins/ViewImage.vue"
export default component.exports